<template>
    <div>
        <component v-bind:is="vueName"></component>
    </div>
</template>
<script>
    export default {
        data: () => {
            return {
                popupName: '1',
                vueName: "",
            }
        },
        components: {
            MailForm: () => import("./MailForm.vue"),
            Thankyou: () => import('./Thankyou.vue'),
            Level: () => import('./Level.vue'),
            Name: () => import('./Name.vue'),
        },
        created: function() {
            this.popupName = this.$route.params.popupname;
            //console.log(this.$route.params.popupname);
            this.loadPopup();
        },
        mounted: function() {
            this.popupName = this.$route.params.popupname;
            this.loadPopup();
        },
        methods: {
            loadPopup() {
                const regex = /^\d{1}_\d{1}$/;
                if(this.popupName == "main_level") {
                    this.vueName = "Level";
                }
                else if(this.popupName == "main_name") {
                    this.vueName = "Name";
                }
                else if(regex.test(this.popupName)) {
                    this.vueName = 'MailForm';
                } else {
                    this.$router.push("/error").catch(()=>{});
                }
            }
        }
    }
</script>